export const interiorSort = (local, interiorItems) => {
    return interiorItems.sort((a, b) => {
        const nameA = local.getLabel(a.name).toLowerCase()
        const nameB = local.getLabel(b.name).toLowerCase()

        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
    })
}
